var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 108C49.0299 108 38.7049 104.398 30.1399 97.58C21.8299 90.9675 15.8749 81.675 13.3699 71.4125C13.0724 70.1925 13.5649 68.9175 14.6049 68.215C15.6449 67.5125 17.0124 67.5325 18.0324 68.265C24.1699 72.67 31.4199 75 38.9999 75C58.8499 75 74.9999 58.85 74.9999 39C74.9999 31.4225 72.6724 24.17 68.2649 18.0325C67.5324 17.0125 67.5124 15.645 68.2149 14.605C68.9174 13.565 70.1949 13.0725 71.4124 13.37C81.6749 15.875 90.9674 21.83 97.5799 30.14C104.395 38.705 108 49.0325 108 60C108 86.4675 86.4674 108 59.9999 108ZM21.7274 77.2975C24.4674 83.335 28.6374 88.7175 33.8749 92.885C41.3674 98.8475 50.4024 102 59.9999 102C83.1599 102 102 83.16 102 60C102 50.4025 98.8474 41.3675 92.8849 33.875C88.7174 28.6375 83.3349 24.47 77.2974 21.7275C79.7349 27.115 80.9999 32.9675 80.9999 39C80.9999 62.16 62.1599 81 38.9999 81C32.9674 81 27.1124 79.735 21.7274 77.2975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNights);
export default __webpack_public_path__ + "static/media/Nights.10b90006.svg";
export { ForwardRef as ReactComponent };